var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('select2',{attrs:{"model":_vm.order.workFlo,"name":"workFlo","options":_vm.autocompleteWorkFlos},on:{"update:model":function($event){return _vm.$set(_vm.order, "workFlo", $event)}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }